
export { KnownContracts } from "/home/runner/work/safe-wallet-monorepo/safe-wallet-monorepo/node_modules/@gnosis.pm/zodiac/dist/esm/factory/types.js"
export { getModuleInstance } from "/home/runner/work/safe-wallet-monorepo/safe-wallet-monorepo/node_modules/@gnosis.pm/zodiac/dist/esm/factory/moduleDeployer.js"